export default {
  widget: {
    title: 'AI Sales Assistant',
    initialMessage: 'Hi, how can I help you?',
    ctaText: 'Ask for information',
    footerText: 'Generated by AI. Please verify important information.',
    placeholder: 'Write a message...',
    placeholderDisabled: 'Demo mode - Input disabled',
    gatePlaceholder: 'Choose an option to continue',
    sendButton: 'Send',
    resetTitle: 'Reset Chat',
    closeTitle: 'Close Chat', // Assuming '×' doesn't need translation, but title might
    poweredBy: 'Powered by',
    demoSuffix: '(Demo)',
  },
  status: {
    thinking: 'Thinking...',
    searching: '🔍 Searching...',
    reconnecting: 'Reconnecting...',
    error: 'A communication error occurred.',
    connectionError: 'A connection error occurred.',
    reconnectFailed:
      'Could not re-establish connection. Please reload the page to try again.',
    configErrorApi: 'Configuration Error: Missing API URL.',
    sendError: 'An error occurred while sending the message.',
    humanAgentJoined: 'An agent has joined the chat.',
    humanAgentLeft: 'The human agent has left the conversation.',
    assistantBack: 'The assistant is back online.'
  },
  product: {
    buyButton: 'Buy',
  },
  demo: {
    // Demo-specific texts if they differ significantly, otherwise reuse from 'widget' or 'status'
    initialMessage: 'Hi, how can I help you?',
    userMessage: 'I\'m looking for comfortable running shoes.',
    botReply: 'Certainly! We have several options. Here is a very popular model known for its comfort and support. You can see more details here:',
    humanAgentReply: "Hi! I'm a human agent jumping in. Here are my personalized picks and next steps for you.",
    ctaText: 'See Shoe XYZ',
  },
};
